const routes = {
  SIGNUP: '/registercustomer',
  SIGN_IN: '/login',
  RESETPASSWORD: '/resetpassword',
  CHANGEPASSWORD: '/changepassword',
  COMPLETEUSERREGISTRATION: '/completeregistration',
  RESENDOTP: '/resendotp',
  VERIFYBVN: '/verifybvn',
  ADDBVN: '/addbvn',
  GETALLBANK: '/banks',
  VERIFYBANKDETAILS: '/accountnamelookup',
  ADDBANKACCOUNT: '/addaccount',
  KYCFORM: '/updatekyc',
  RECENTTRANSACT: '/transactions/recent',
  WALLETBALANCE: '/Wallet/balance',
  WALLETTOPUP: '/Wallet/topup',
  CREATEFIXEDSAVINGS: '/FixedSavings/create',
  CREATEPERSONALTARGETSAVINGS: '/TargetSavings/personal/create',
  GETCUSTOMERCARDS: '/customercards',
  GETCUSTOMERACCT: '/customeraccounts',
  TOTALSAVINGS: '/Savings/total',
  CREATEGROUPTARGETSAVINGS: '/TargetSavings/group/create',
  GETSAVINGPLANS: '/Savings/plan',
  GETUSERNOTIFICATION: '/notifications',
  GETSINGLESAVING: '/TargetSavings/single',
  GETGROUPNOTIFICATION: '/TargetSavings/group/invitation',
  TREATGROUPINVITATION: '/TargetSavings/group/treatinvitation',
  GETSINGLEFIXEDDETAILS: '/FixedSavings/single',
  CREATEGROUPSCHEME: '/GroupContributoryScheme/create',
  GETGROUPCONTRIBUTEINVITE: '/GroupContributoryScheme/invitation',
  TREATGROUPSCHEMEINVITE: '/GroupContributoryScheme/treatinvitation',
  BUYMONEYMARKETFUND: '/MutualFunds/subscribe',
  FIXTIPINVESTMENT: '/Investments/fixtip',
  DELETEUSERCARD: '/customercard/delete',
  GETMUTUALFUND: '/MutualFunds',
  DELETEUSERBANK: '/customeraccount/delete',
  GETFIXTIPINVEST: '/Investments/fixtip',
  MTLIPINVESTMENT: '/Investments/mtlip',
  GETMTLIPINVEST: '/Investments/mtlip',
  WITHDRAWMTLIPINVESTMENT: '/Investments/mtlip/withdraw',
  WITHDRAWFIXTIPINVESTMENT: '/Investments/fixtip/withdraw',
  REDEEMMUTUALFUND: '/MutualFunds/Redeem',
  ROBOADVISORY: '/RoboAdvisory/fillquestionaire',
  WITHDRAWFIXEDSAVINGS: '/FixedSavings/withdraw',
  WITHDRAWTARGETSAVINGS: '/TargetSavings/withdraw',
  UPLOADPROFILEPIC: '/uploadphoto',
};

export default routes;
